import {isNotNilOrEmpty} from 'ramda-adjunct';

import type {GetDataByDataQueryApiResponse} from '@dms/api/core';

import {EMPTY_PLACEHOLDER} from 'shared/web';

import {Card} from '../types/Card';
import {getColumnForState} from './getColumnForState';
import {getUnreadMessageCount} from './getUnreadMessageCount';

export function mapBusinessCasesToCards(businessCases: GetDataByDataQueryApiResponse): Card[] {
  /* eslint-disable complexity -- Pre-existing violation */
  return businessCases.rows
    .filter((row) => isNotNilOrEmpty(row.cells))
    .map((row) => ({
      id: row.id,
      column: row.cells?.businessCaseState?.value?.key
        ? getColumnForState(row.cells.businessCaseState.value.key)
        : null,
      title: row.cells.vehicle?.value?.label || EMPTY_PLACEHOLDER,
      subTitle: row.cells.customerName?.value?.label || EMPTY_PLACEHOLDER,
      customerId: row.cells.customerName?.value?.id ?? null,
      flags:
        row.cells.tag?.value?.map((tag: Record<string, string>) => ({
          label: tag.label,
          colorScheme: tag.color,
        })) || null,
      unreadMessageCount: getUnreadMessageCount(row.cells.unreadMessageCount?.value),
      note: typeof row.cells.note?.value === 'string' ? row.cells.note.value : null,
      price: row.cells.businessCasePrice?.value || row.cells.vehiclePriceWithVat?.value || null,
      date:
        row.cells.businessCaseUpdatedAt?.value || row.cells.businessCaseCreatedAt?.value || null,
      lastActivityDate: row.cells.lastActivityDate?.value ?? null,
      lastCommunicationDate: row.cells.lastCommunicationDate?.value ?? null,
      lastCommunicationChannel: row.cells.lastCommunicationChannel?.value?.key ?? null,
      ownerId: row.cells.owner?.value?.id || null,
      origin: 'business-case',
    }));
  /* eslint-enable complexity */
}
